import { createSelector } from '@reduxjs/toolkit';
import { incApi } from 'api/inc-api';

export const selectMerchant = state => state.app.merchant;

export const selectMerchantsQuery = incApi.endpoints.listMerchants.select();

export const selectCurrentMerchantId = createSelector(
  selectMerchant,
  merchant => merchant.current,
);

export const selectCurrentMerchant = createSelector(
  selectCurrentMerchantId,
  selectMerchantsQuery,
  (merchantId, merchantsQuery) =>
    merchantsQuery?.data?.merchants?.find(
      merchant => merchant.merchantId === merchantId,
    ),
);

export const selectMerchantList = createSelector(
  selectMerchantsQuery,
  merchantsQuery => merchantsQuery?.data?.merchants ?? [],
);
